type MapPinLocation = {
  latitude?: unknown;
  longitude?: unknown;
} | null;

const hasCoordinate = (value: unknown): boolean =>
  value !== null && value !== undefined && value !== '';

export const hasMapPin = (location?: MapPinLocation): boolean => {
  return hasCoordinate(location?.latitude) && hasCoordinate(location?.longitude);
};

type CountableTimeline = {
  accommodations?: Array<{ location?: MapPinLocation }>;
  engagements?: Array<{
    activity?: { includedOnWebsiteItinerary?: boolean | null } | null;
    startMapLocation?: MapPinLocation;
  }>;
};

export const countMissingMapLocations = (timeline: CountableTimeline): number => {
  const missingAccommodations = (timeline.accommodations ?? []).filter(
    (accommodation) => !hasMapPin(accommodation.location),
  ).length;
  const missingActivities = (timeline.engagements ?? []).filter(
    (engagement) =>
      engagement.activity?.includedOnWebsiteItinerary &&
      !hasMapPin(engagement.startMapLocation),
  ).length;

  return missingAccommodations + missingActivities;
};
